var classes = {"compareSliderContainer":"kEa2J","compareSliderGrid":"TddGY","compareSliderContentContainer":"oLhNR","compareCarouselSliderGrid":"CwktM"};

export { classes as default };
